import { useCookie } from 'react-use';
import { v4 as uuid } from 'uuid';

import { useLocalStorage } from '../../../utils/hooks/useLocalStorage';

export function useQuizStudentId() {
    const localStorage = useLocalStorage();

    const [icookie] = useCookie('i');
    const [yandexuid] = useCookie('yandexuid');

    if (icookie !== null) {
        return icookie;
    }

    if (yandexuid !== null) {
        return yandexuid;
    }

    const quizStudentId = localStorage.get('quizStudentId');

    if (quizStudentId) {
        return quizStudentId;
    }

    const id = uuid();

    localStorage.set('quizStudentId', id);

    return id;
}
